export default __webpack_public_path__ + "static/media/404.092aa584.png";